<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.titulo"
          label="Título do relatório administrativo"
          :readonly="true"
        ></v-text-field>
      </v-col>

      <v-col
        v-if="isFullAdmin || (config.verContrato && groupsConfig.verContrato)"
      >
        <ComboboxContratoByUser
          :filter="payload"
          :user="user.usuarioId"
        ></ComboboxContratoByUser>
      </v-col>

      <v-col sm="2" class="text-right">
        <v-btn
          v-if="isAdmin || user.usuarioId === payload.usuarioId"
          outlined
          color="primary"
          class="ml-3"
          @click="update(payload)"
        >
          <span>Atualizar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <SmartDateInput
          v-model="payload.inicioString"
          label="Data de Início"
          placeholder="00/00/0000 00:00"
          :include-time="true"
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        />
      </v-col>

      <v-col>
        <SmartDateInput
          v-model="payload.fimString"
          label="Data de Término"
          placeholder="00/00/0000 00:00"
          :include-time="true"
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="payload.horas"
          label="Horas Correspondentes"
          placeholder="0"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>

        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              v-model="payload.descricao"
              :readonly="
                payload.statusRelatorioId === 2 ||
                payload.statusRelatorioId === 4
              "
            ></v-textarea>
          </v-col>
        </v-tab-item>

        <v-tab-item>
          <v-col
            v-if="
              payload.statusRelatorioId !== 2 && payload.statusRelatorioId !== 4
            "
          >
            <template>
              <v-file-input
                multiple
                label="File input"
                v-model="payload.arquivos"
              >
              </v-file-input>
            </template>
          </v-col>
          <v-data-table
            :headers="headersAnexos"
            :items="payload.anexos"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.download="{ item }">
              <v-btn
                outlined
                color="primary"
                class="ml-3"
                @click="downloadAnexo(item)"
              >
                <span>Download</span>
              </v-btn>
              <v-btn
                v-if="
                  payload.statusRelatorioId !== 2 &&
                  payload.statusRelatorioId !== 4
                "
                outlined
                color="red"
                class="ml-3"
                @click="excluirAnexo(item)"
              >
                <span>Excluir</span>
              </v-btn>
            </template>

            <template slot="no-data">
              <span> Nenhum anexo retornado </span>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { administrativeReportAPI } from "@/modules/administrative-report";
import { AppCityHeader } from "@/modules/city";
import ComboboxContratoByUser from "@/modules/contratos/components/ComboboxByUser.vue";
import SmartDateInput from "@/components/SmartDateInput.vue";
import moment from "moment";
import { dataHoraRegexValidator } from "@/helpers/validator";
import Swal from "sweetalert2";
export default {
  components: {
    AppCityHeader,
    ComboboxContratoByUser,
    SmartDateInput,
  },
  data() {
    return {
      payload: {
        arquivos: [],
      },
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
    };
  },
  methods: {
    ...mapActions(["setLoading", "setAnalistaMunicipio", "setADMunicipio"]),
    get() {
      this.setLoading(true);
      administrativeReportAPI
        .get(this.$route.params.relatorio)
        .then((resp) => {
          this.payload = resp.data;
          this.payload.inicioString = moment(this.payload.inicio).format(
            "DD/MM/YYYY HH:mm"
          );
          this.payload.fimString = moment(this.payload.fim).format(
            "DD/MM/YYYY HH:mm"
          );
          this.payload.contratos = resp.data.contrato || {};
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório");
        });
    },
    excluirAnexo(evidencia) {
      Swal.fire({
        title: "Confirma a exclusão do anexo?",
        text: "Esta ação não poderá ser desfeita",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);
          administrativeReportAPI
            .deleteAnexo(evidencia.relatorioAdministrativoAnexoId)
            .then((resp) => {
              this.get();
              this.setLoading(false);
              this.$notification.success("Anexo excluído com sucesso");
            })
            .catch((resp) => {
              this.setLoading(false);
              this.$notification.error("Erro ao excluir anexo");
            });
        }
      });
    },
    downloadAnexo(evidencia) {
      administrativeReportAPI
        .downloadAnexo(evidencia.relatorioAdministrativoAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    update(relatorio) {
      if (!this.payload.inicioString || this.payload.inicioString.length < 16) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de início do relatório"
        );
      } else if (
        !this.payload.fimString ||
        this.payload.fimString.length < 16
      ) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de término do relatório"
        );
      } else if (
        !dataHoraRegexValidator.test(this.payload.inicioString) ||
        !dataHoraRegexValidator.test(this.payload.fimString)
      ) {
        this.$notification.error("Data final ou inicial está inválida.");
      } else if (
        moment(this.payload.fimString, "DD/MM/YYYY HH:mm").isBefore(
          moment(this.payload.inicioString, "DD/MM/YYYY HH:mm")
        )
      ) {
        this.$notification.error(
          "A data final do relatório não pode ser menor que a data inicial do relatório"
        );
      } else if (
        moment(this.payload.inicioString, "DD/MM/YYYY HH:mm").isBefore(
          moment().subtract(1, "year")
        )
      ) {
        this.$notification.error(
          "A data inicial do relatório não pode ser anterior a 1 ano"
        );
      } else if (
        moment(this.payload.fimString, "DD/MM/YYYY HH:mm").isAfter(
          moment().add(1, "year")
        )
      ) {
        this.$notification.error(
          "A data final do relatório não pode ser superior a 1 ano"
        );
      } else if (!this.payload.horas) {
        this.$notification.error(
          "As horas correspondentes devem estar preenchidas"
        );
      } else if (!this.payload.titulo) {
        this.$notification.error("O título deve estar preenchido");
      } else if (!this.payload.descricao) {
        this.$notification.error("A descrição deve estar preenchida");
      } else if (
        !this.payload.contratos ||
        !this.payload.contratos.contratoId
      ) {
        this.$notification.error("O contrato deve estar preenchido");
      } else {
        this.setLoading(true);
        let formData = new FormData();

        if (this.payload.arquivos) {
          for (let i = 0; i < this.payload.arquivos.length; i++) {
            formData.append("arquivos", this.payload.arquivos[i]);
          }
        }

        formData.append("descricao", this.payload.descricao);
        formData.append("municipioId", this.payload.municipioId);
        formData.append("usuarioId", this.payload.usuarioId);
        formData.append(
          "relatorioAdministrativoId",
          this.payload.relatorioAdministrativoId
        );
        formData.append("statusRelatorioId", this.payload.statusRelatorioId);
        formData.append("titulo", this.payload.titulo);
        formData.append("inicioString", this.payload.inicioString);
        formData.append("fimString", this.payload.fimString);
        formData.append("criacaoString", this.payload.criacaoString);
        formData.append(
          "contratoId",
          this.payload.contratos && this.payload.contratos.contratoId
        );
        formData.append("horas", this.payload.horas);
        if (this.payload.motivoRejeicao) {
          formData.append("motivoRejeicao", this.payload.motivoRejeicao);
        }

        administrativeReportAPI
          .update(formData)
          .then((resp) => {
            this.get();
            this.setLoading(false);
            this.$notification.success("Relatório Administrativo Atualizado");
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              "Erro ao atualizar relatório administrativo"
            );
          });
      }
    },
  },
  mounted() {
    this.get();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isADMunicipio",
      "isAuthenticated",
      "user",
      "config",
      "groupsConfig",
      "isFullAdmin",
    ]),
  },
};
</script>
